import { render, staticRenderFns } from "./AppTableIngresosLey.vue?vue&type=template&id=36f50360&scoped=true"
import script from "./AppTableIngresosLey.vue?vue&type=script&lang=js"
export * from "./AppTableIngresosLey.vue?vue&type=script&lang=js"
import style0 from "./AppTableIngresosLey.vue?vue&type=style&index=0&id=36f50360&prod&lang=scss&scoped=true"
import style1 from "./AppTableIngresosLey.vue?vue&type=style&index=1&id=36f50360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f50360",
  null
  
)

export default component.exports